import React, { useEffect, useRef } from "react";
import { useSquarespaceContent } from "../hooks/useSquarespaceContent";

const HeroSection = () => {
  const { content } = useSquarespaceContent();
  const videoRef = useRef(null);
  const backgroundRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    // Only add scroll listener if content is loaded
    if (!content || !content.hero) return;

    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const video = videoRef.current;
      const background = backgroundRef.current;
      const contentElement = contentRef.current;

      if (video) {
        const rate = scrolled * -0.5;
        video.style.transform = `translateX(-50%) translateY(calc(-50% + ${rate}px))`;
      }
      
      if (background) {
        const rate = scrolled * -0.5;
        background.style.transform = `translateY(${rate}px)`;
      }
      
      if (contentElement && scrolled < window.innerHeight) {
        const contentRate = scrolled * -0.3;
        contentElement.style.transform = `translateY(${contentRate}px)`;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [content]);

  useEffect(() => {
    // Only animate content if it's loaded
    if (!content || !content.hero) return;

    // Animate content on load
    const contentElement = contentRef.current;
    if (contentElement) {
      contentElement.style.opacity = "0";
      contentElement.style.transform = "translateY(50px)";
      
      setTimeout(() => {
        contentElement.style.transition = "all 1.2s cubic-bezier(0.4, 0, 0.2, 1)";
        contentElement.style.opacity = "1";
        contentElement.style.transform = "translateY(0)";
      }, 500);
    }
  }, [content]);

  // Safety check - if content is not loaded yet, show loading state
  if (!content || !content.hero) {
    return (
      <section id="hero" className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Loading...</h1>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="hero" className="hero-section">
      {/* Video Background */}
      <video 
        ref={videoRef}
        className="hero-video parallax-element" 
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src={content.hero.backgroundVideo.replace('{variant}', '1920:1080')} type="video/mp4" />
        <source src={content.hero.backgroundVideo.replace('{variant}', '640:360')} type="video/mp4" />
      </video>
      
      {/* Fallback Background Image */}
      <div 
        ref={backgroundRef}
        className="hero-background parallax-element"
        role="img"
        aria-label="ATSOMNIUM gaming excellence background"
      />
      
      <div className="hero-overlay" />
      
      <div ref={contentRef} className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            {content.hero.title}
          </h1>
          <p className="hero-subtitle">
            {content.hero.subtitle}
          </p>
          <div className="hero-actions">
            <button 
              className="btn btn-primary"
              onClick={() => document.getElementById("about").scrollIntoView({ behavior: "smooth" })}
            >
              Learn More
            </button>
            <button 
              className="btn btn-outline"
              onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;